import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const OccurenceLocationChartsDataContext = createContext();

const OccurenceLocationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.OCCURENCE_LOCATION_MORTALITY,
            url: 'governanceroom/dashboard/vitalstatistics/mortality/occurence'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              counterByCity: data?.counterByCity ?? [],
              ocurrenceLocation: data?.ocurrenceLocation ?? [],
              ocurrenceNeighborhood: data?.ocurrenceNeighborhood ?? [],
              residentialNeighborhood: data?.residentialNeighborhood ?? []
          }
        : {
              counterByCity: [],
              ocurrenceLocation: [],
              ocurrenceNeighborhood: [],
              residentialNeighborhood: []
          };

    return (
        <OccurenceLocationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </OccurenceLocationChartsDataContext.Provider>
    );
};

export default OccurenceLocationChartsDataProvider;
